import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=dfafcb26&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=dfafcb26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfafcb26",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/test-e-youhuo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dfafcb26')) {
      api.createRecord('dfafcb26', component.options)
    } else {
      api.reload('dfafcb26', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=dfafcb26&scoped=true&", function () {
      api.rerender('dfafcb26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/task/customerTask/detail.vue"
export default component.exports